exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.cta-accordion-icon,.cta-accordion-icon svg{min-width:40px;max-width:40px;min-height:40px;max-height:40px}[dir] .cta-accordion-icon svg{border-radius:50%;border:1px solid #fff;padding:9px;background-color:#3f3d3d}.cta-accordion-icon svg polyline{stroke-width:25}[dir=ltr] .cta-accordion-icon.cta-expand{transform:rotate(90deg)}[dir=ltr] .cta-accordion-icon.cta-collapse,[dir=rtl] .cta-accordion-icon.cta-expand{transform:rotate(-90deg)}[dir=rtl] .cta-accordion-icon.cta-collapse{transform:rotate(90deg)}.base-accordion,.base-accordion .card-header{display:block}[dir] .base-accordion .card-header{cursor:pointer}.base-accordion .card-header:hover{text-decoration:none}@media (max-width:767px){[dir] .base-accordion .card-body{padding-bottom:5px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/base-accordion/base-accordion.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/base-accordion/base-accordion.component.scss
// module chunks = 0